export default __webpack_public_path__ + "static/media/EventoRed.ead16917.svg";